import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-55ac40a2"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src"]

import { computed } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'MImage',
  props: {
  src: String,
  class: String,
  style: Object,
  type: String, // avatar
},
  setup(__props) {

const props = __props;


const resourceOrigin = process.env.VUE_APP_RESOURCES_URL
const imgSrc = computed(() => {
  if (
    props.src?.indexOf('http') === 0 ||
    props.src?.indexOf('//') === 0 ||
    props.src?.indexOf('data') === 0
  ) {
    return props.src
  }
  return `${resourceOrigin}${props.src}`
})
const handleError = (e: any) => {
  if (props.type === 'avatar') {
    e.target.src = require('@/assets/image/user/avatar.png')
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("img", {
    src: _unref(imgSrc),
    class: _normalizeClass(props.class + (props.type === 'avatar' ? ' fit-cover' : '')),
    style: _normalizeStyle(props.style),
    onError: handleError
  }, null, 46, _hoisted_1))
}
}

})